export const ERROR_MESSAGE = {
  REQUIRED: (label: string) => `${label}を入力してください。`,
  REQUIRED_SELECT: (label: string) => `${label}を選択してください。`,
  TOO_SHORT: "文字数が足りません。",
  NO_SYMBOLS: (label: string) => `記号は${label}に使用できません。`,
  UNMATCHED: (label: string) => `${label}が異なります。`,
  INVALID_FORMAT: (label: string) => `${label}の形式が無効です。`,
  KATAKANA: "カタカナで入力してください。",
  ONLY: (label: string) => `${label}のみ入力してください。`,
  END_BEFORE_START: (endLabel: string, startLabel: string) => `${endLabel}は${startLabel}より後の必要があります。`,
};
